import React from 'react';

import { BrandChefsProvider } from 'contexts/brand-chefs.context';
import BrandChefsContent from './content';

const BrandChefsLayout = () => {
  return (
    <BrandChefsProvider>
      <BrandChefsContent />
    </BrandChefsProvider>
  );
};

export default BrandChefsLayout;
